import React, { useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import LoginFrame from '../components/loginFrame';
import ChangePassword from '../components/changepwd';
import AppService from "s2s-app-service";
import { processServiceErrorsToAlerts } from '../js/utilities';

import useAlerts from '../hooks/alerts';
import { getDomainConfig } from "../domainconfigs/domainconfig";

const ChangePwdRoute = (props) => {

  const [state, setState] = useState({ 'currentState': 'validatingToken' });
  const [, { createErrorAlert }] = useAlerts();

  const domainConfig = getDomainConfig(window.location.host);

  const validateToken = async () => {
    const token = props.location.search.split('&').reduce((p, c) => {
      if (p) return p;
      if (c.indexOf("token=") > -1) {
        return c.substring(c.indexOf("=") + 1);
      }
      return p;
    }, undefined);

    console.log('TOKEN----->', token);

    try {
      if (!token) {
        console.error('NO TOKEN FOUND FOR CHANGE PWD');
        let error = new Error(`{"statusCode": "1001", "message":"Missing token for change password.  Please retry 'Forgot password'."}`);

        throw (error);

      } else {
        console.log(`token to validate is: ${token}`);
        // try {
        const responseData = await AppService.getInstance().accountHelper({ "action": "validate", "password_token": token });
        console.log('validate: ', responseData);
        setState({ ...state, "currentState": "change", ...responseData });
      }
    } catch (e) {
      console.error('validate token failed with: ', e);
      const { alertHeading:message, alertBody } = processServiceErrorsToAlerts(e, props.intl);

      createErrorAlert({
        message: message || 'Change Password',
        details: [alertBody || 'Change Password'],
        autoCloseTimeout: 15,
      });

      props.history.push('/');
    }
  };


  useEffect(() => { validateToken(); }, []);


  const handleCancelClick = () => {
    props.history.push('/');
  };

  const handleResetClick = (password) => {
    console.log('handle reset called: ', password, state.currentState, state.token);

    AppService.getInstance().accountHelper({ "action": "reset", "password_token": state.token, body: { "email": state.email, "password": password } }).then(() => {
      props.history.push('/');
    }).catch((e) => {
      console.error('reset failed with: ', e.message);

      // Temporary special handling until we figure out how we want to deal with errors and error codes
      // long term
      const errorObj = JSON.parse(e.message);

      let newError = e;

      if (errorObj.statusCode.toString() === '400') {
        if (errorObj.message.indexOf('cannot match') !== -1) {
          console.log('NEW PWD CANNOT MATCH');
          newError = new Error(JSON.stringify({ "statusCode": "1002", "message": "New password cannot match previous password" }));
        } else if (errorObj.message.indexOf('8 or more characters') !== -1) {
          console.log('NEW PWD does not meet required criteria');
          newError = new Error(JSON.stringify({ "statusCode": "1003", "message": "Password should contain at least one letter, at least one number, no white space, not start with @, and 8 or more characters." }));
        } else {
          console.log('Other change pwd error', errorObj);

          newError = new Error(JSON.stringify({ "statusCode": "1004", "message": "Error changing password.  Please try again.  If problem persists, contact Technical Suport" }));
        }
      }

      // Non-400 errors will just get passed on to processor for now.
      const { alertHeading:message, alertBody } = processServiceErrorsToAlerts(newError, props.intl);

      createErrorAlert({
        message,
        details: [alertBody],
        autoCloseTimeout: 15,
      });
    });
  };


  console.log('CURRENT STATE===>', state.currentState);
  const Component = state.currentState === "validatingToken" ?
    (<p>Validating Token</p>) :
    (<ChangePassword cbCancelClick={handleCancelClick} cbResetClick={handleResetClick} />);

  return (
    <div
      className="changePwdRoute"
      style={{ display: 'flex', height: '100%', width: '100%' }}
    >
      <LoginFrame
        appName={domainConfig.appName}
        companyName={domainConfig.companyName}
        imageSource={domainConfig.appLogo}
        isChangePasswordScreen // so can change the text to say "change password for..."
        showAppInfo
      >
        {Component}
      </LoginFrame>


    </div>
  );
};

ChangePwdRoute.propTypes = {
  'intl': PropTypes.object,
  'history': PropTypes.object,
  'location': PropTypes.object,
};


export default injectIntl(ChangePwdRoute);